import FilterActionTypes from './filter-types';

export const updateProjectFiltersApplied = (projectFiltersApplied) => ({
    type: FilterActionTypes.UPDATE_PROJECTS_FILTER_APPLIED,
    payload: projectFiltersApplied
})

export const updateProjectFilterOptionsTotal = (totalProjectFilters) => ({
    type: FilterActionTypes.UPDATE_PROJECTS_FILTER_OPTIONS_TOTAL,
    payload: totalProjectFilters
})

export const updateProjectFiltersConjunctionSelection = (conjunctionSelection) => ({
    type: FilterActionTypes.UPDATE_PROJECTS_FILTER_CONJUNCTION_SELECTION,
    payload: conjunctionSelection
})

export const updateTaskFiltersApplied = (taskFilters) => ({
    type: FilterActionTypes.UPDATE_TASKS_FILTER_APPLIED,
    payload: taskFilters
})

export const updateTaskFilterOptionsTotal = (totalTaskFilters) => ({
    type: FilterActionTypes.UPDATE_TASKS_FILTER_OPTIONS_TOTAL,
    payload: totalTaskFilters
})

export const updateTaskFilterConjunctionSelection = (conjunctionSelection) => ({
    type: FilterActionTypes.UPDATE_TASKS_FILTER_CONJUNCTION_SELECTION,
    payload: conjunctionSelection
})

export const clearAllFilters = () => ({
    type: FilterActionTypes.CLEAR_ALL_FILTERS
})